export interface Work {
  id: number;
  title: string;
  category: "插画" | "壁纸" | "画集";
  tag: string;
  artist: string;
  likes: number;
  views: number;
  image: string;
  ratio: string;
}

export interface Artist {
  id: number;
  name: string;
  alias: string;
  style: string;
  works: number;
  fans: number;
  avatar: string;
  intro: string;
}

export interface Collection {
  id: number;
  name: string;
  cover: string;
  count: number;
  desc: string;
}

export interface FaqItem {
  q: string;
  a: string;
}

export const navLinks = [
  { label: "首页", href: "#top" },
  { label: "精选作品", href: "#works" },
  { label: "分类鉴赏", href: "#categories" },
  { label: "系列画集", href: "#collections" },
  { label: "画师专栏", href: "#artists" },
  { label: "常见问题", href: "#faq" },
];

export const categories = [
  { name: "插画精选", desc: "光影细腻的日常与幻想瞬间", icon: "ri-brush-4-line", count: 486 },
  { name: "高清壁纸", desc: "为手机与桌面而生的纵享高清", icon: "ri-image-2-line", count: 312 },
  { name: "系列画集", desc: "画师整本收录,连载的完整世界", icon: "ri-book-open-line", count: 128 },
  { name: "画师专栏", desc: "追踪心仪画师的最新动态", icon: "ri-user-heart-line", count: 96 },
];

export const works: Work[] = [
  {
    id: 1,
    title: "橘子镇的午后",
    category: "插画",
    tag: "日常",
    artist: "枫间晓",
    likes: 4820,
    views: 12800,
    image: "https://readdy.ai/api/search-image?query=anime%20illustration%20of%20a%20cheerful%20young%20woman%20with%20long%20bright%20orange%20hair%20and%20warm%20smile%20holding%20a%20fresh%20tangerine%2C%20sunlit%20seaside%20village%20background%20with%20citrus%20trees%2C%20soft%20golden%20afternoon%20light%2C%20clean%20painterly%20digital%20art%2C%20gentle%20expressive%20pose%2C%20high%20quality%20anime%20fan%20art%2C%20warm%20color%20palette&width=800&height=1000&seq=nami-w-01&orientation=portrait",
    ratio: "aspect-[4/5]",
  },
  {
    id: 2,
    title: "星图与罗盘",
    category: "插画",
    tag: "奇幻",
    artist: "夏橘",
    likes: 3560,
    views: 9610,
    image: "https://readdy.ai/api/search-image?query=anime%20illustration%20of%20a%20young%20woman%20with%20orange%20hair%20studying%20an%20ancient%20star%20chart%20beside%20a%20brass%20compass%20at%20night%2C%20soft%20starlight%20and%20lantern%20glow%2C%20fantasy%20navigator%20theme%2C%20rich%20warm%20amber%20and%20deep%20teal%20tones%2C%20painterly%20digital%20art%2C%20cinematic%20mood%2C%20high%20detail&width=800&height=1000&seq=nami-w-02&orientation=portrait",
    ratio: "aspect-[4/5]",
  },
  {
    id: 3,
    title: "晴空下的眺望",
    category: "壁纸",
    tag: "海风",
    artist: "罗盘先生",
    likes: 6280,
    views: 22400,
    image: "https://readdy.ai/api/search-image?query=stunning%20anime%20wallpaper%20of%20a%20young%20woman%20with%20flowing%20orange%20hair%20gazing%20at%20the%20open%20ocean%20from%20a%20ship%20bow%2C%20golden%20hour%20sunset%2C%20sparkling%20sea%20waves%2C%20white%20sails%20and%20seagulls%2C%20warm%20uplifting%20atmosphere%2C%20high%20resolution%20landscape%20wallpaper%2C%20painterly%20digital%20art%2C%20breathtaking%20composition&width=1280&height=800&seq=nami-w-03&orientation=landscape",
    ratio: "aspect-[16/10]",
  },
  {
    id: 4,
    title: "果实与浪花",
    category: "插画",
    tag: "治愈",
    artist: "阿汐",
    likes: 2910,
    views: 7430,
    image: "https://readdy.ai/api/search-image?query=anime%20illustration%20of%20a%20young%20woman%20with%20orange%20hair%20sitting%20under%20a%20tangerine%20tree%20by%20the%20shore%20with%20gentle%20waves%2C%20holding%20a%20slice%20of%20fruit%2C%20soft%20dappled%20sunlight%2C%20wholesome%20cozy%20healing%20scene%2C%20delicate%20watercolor%20style%2C%20warm%20pastel%20palette%2C%20tranquil%20mood&width=800&height=1000&seq=nami-w-04&orientation=portrait",
    ratio: "aspect-[4/5]",
  },
  {
    id: 5,
    title: "远航之夜",
    category: "壁纸",
    tag: "星光",
    artist: "潮汐信使",
    likes: 4150,
    views: 13800,
    image: "https://readdy.ai/api/search-image?query=anime%20wallpaper%20of%20a%20young%20woman%20with%20orange%20hair%20on%20a%20ship%20deck%20under%20a%20starry%20night%20sky%2C%20warm%20lantern%20light%20and%20moonlight%2C%20reflection%20on%20dark%20ocean%2C%20serene%20mystical%20mood%2C%20deep%20blue%20and%20warm%20amber%20contrast%2C%20high%20detail%20landscape%20wallpaper%2C%20painterly%20digital%20art&width=1280&height=800&seq=nami-w-05&orientation=landscape",
    ratio: "aspect-[16/10]",
  },
  {
    id: 6,
    title: "罗盘与橘子",
    category: "画集",
    tag: "收录",
    artist: "枫间晓",
    likes: 5340,
    views: 16700,
    image: "https://readdy.ai/api/search-image?query=anime%20illustration%20of%20a%20young%20woman%20with%20orange%20hair%20holding%20a%20compass%20and%20a%20basket%20of%20tangerines%20at%20a%20sunlit%20dockside%2C%20traveler%20navigator%20vibe%2C%20warm%20golden%20light%2C%20clean%20painterly%20digital%20art%2C%20rich%20storytelling%20composition%2C%20high%20quality%20collection%20cover&width=800&height=1000&seq=nami-w-06&orientation=portrait",
    ratio: "aspect-[4/5]",
  },
  {
    id: 7,
    title: "海风的信",
    category: "插画",
    tag: "信件",
    artist: "阿汐",
    likes: 2380,
    views: 6210,
    image: "https://readdy.ai/api/search-image?query=anime%20illustration%20of%20a%20young%20woman%20with%20orange%20hair%20writing%20a%20letter%20at%20a%20wooden%20table%20near%20an%20open%20window%20overlooking%20the%20sea%2C%20breeze%20lifting%20the%20curtains%2C%20warm%20afternoon%20light%2C%20nostalgic%20gentle%20mood%2C%20soft%20painterly%20style%2C%20delicate%20details%2C%20emotional%20warm%20palette&width=800&height=1000&seq=nami-w-07&orientation=portrait",
    ratio: "aspect-[4/5]",
  },
  {
    id: 8,
    title: "橘色地平线",
    category: "画集",
    tag: "连载",
    artist: "夏橘",
    likes: 3710,
    views: 10400,
    image: "https://readdy.ai/api/search-image?query=anime%20illustration%20of%20a%20young%20woman%20with%20orange%20hair%20standing%20on%20a%20cliff%20overlooking%20a%20vast%20orange%20and%20pink%20sunset%20horizon%20over%20the%20sea%2C%20billowing%20hair%20in%20the%20wind%2C%20inspiring%20epic%20mood%2C%20warm%20sunset%20gradient%20sky%2C%20painterly%20digital%20art%2C%20series%20collection%20cover%20art%2C%20high%20detail&width=800&height=1000&seq=nami-w-08&orientation=portrait",
    ratio: "aspect-[4/5]",
  },
  {
    id: 9,
    title: "掌舵的少女",
    category: "壁纸",
    tag: "热血",
    artist: "罗盘先生",
    likes: 5080,
    views: 18900,
    image: "https://readdy.ai/api/search-image?query=anime%20wallpaper%20of%20a%20confident%20young%20woman%20with%20orange%20hair%20steering%20a%20ship%20wheel%20amidst%20sunlit%20spray%20and%20waves%2C%20dynamic%20heroic%20pose%2C%20golden%20sunlight%2C%20determined%20expression%2C%20high%20energy%20adventure%20mood%2C%20high%20resolution%20landscape%20wallpaper%2C%20painterly%20digital%20art&width=1280&height=800&seq=nami-w-09&orientation=landscape",
    ratio: "aspect-[16/10]",
  },
  {
    id: 10,
    title: "天候的秘密",
    category: "插画",
    tag: "战斗",
    artist: "潮汐信使",
    likes: 4620,
    views: 12100,
    image: "https://readdy.ai/api/search-image?query=anime%20illustration%20of%20a%20young%20woman%20with%20orange%20hair%20holding%20a%20weather%20staff%20with%20glowing%20weather%20clouds%20swirling%20around%2C%20dramatic%20sky%20with%20lightning%20and%20sunbeams%2C%20dynamic%20magical%20scene%2C%20warm%20and%20electric%20contrast%2C%20high%20impact%20painterly%20digital%20art%2C%20cinematic%20lighting&width=800&height=1000&seq=nami-w-10&orientation=portrait",
    ratio: "aspect-[4/5]",
  },
  {
    id: 11,
    title: "夏日的集市",
    category: "壁纸",
    tag: "街景",
    artist: "夏橘",
    likes: 3270,
    views: 9820,
    image: "https://readdy.ai/api/search-image?query=anime%20wallpaper%20of%20a%20young%20woman%20with%20orange%20hair%20walking%20through%20a%20colorful%20sunny%20seaside%20market%20with%20fruits%20and%20maps%2C%20bright%20cheerful%20summer%20day%2C%20lively%20atmosphere%2C%20warm%20golden%20light%2C%20high%20resolution%20landscape%20wallpaper%2C%20vibrant%20detail%2C%20painterly%20digital%20art&width=1280&height=800&seq=nami-w-11&orientation=landscape",
    ratio: "aspect-[16/10]",
  },
  {
    id: 12,
    title: "船长的委托",
    category: "画集",
    tag: "冒险",
    artist: "枫间晓",
    likes: 2980,
    views: 8450,
    image: "https://readdy.ai/api/search-image?query=anime%20illustration%20of%20a%20young%20woman%20with%20orange%20hair%20reading%20a%20treasure%20map%20under%20a%20warm%20lantern%20glow%20at%20dusk%2C%20cozy%20mysterious%20adventure%20mood%2C%20wooden%20table%20with%20old%20charts%20and%20coins%2C%20amber%20and%20indigo%20tones%2C%20storytelling%20collection%20art%2C%20painterly%20digital%20art%2C%20high%20detail&width=800&height=1000&seq=nami-w-12&orientation=portrait",
    ratio: "aspect-[4/5]",
  },
];

export const collections: Collection[] = [
  {
    id: 1,
    name: "《橘子海域》日常篇",
    cover: "https://readdy.ai/api/search-image?query=anime%20collection%20cover%20of%20a%20young%20woman%20with%20orange%20hair%20smiling%20in%20a%20cozy%20seaside%20town%2C%20collecting%20tangerines%2C%20soft%20warm%20morning%20light%2C%20slice%20of%20life%20mood%2C%20painterly%20digital%20art%2C%20gallery%20collection%20book%20cover%2C%20warm%20orange%20and%20cream%20palette%2C%20high%20detail&width=800&height=1000&seq=nami-c-01&orientation=portrait",
    count: 42,
    desc: "收录枫间晓笔下充满阳光与果香的温馨日常,适合作为心情收藏。",
  },
  {
    id: 2,
    name: "《航海家的星辰》",
    cover: "https://readdy.ai/api/search-image?query=anime%20collection%20cover%20of%20a%20young%20woman%20with%20orange%20hair%20under%20a%20vast%20starry%20night%20sky%20holding%20a%20glowing%20compass%2C%20epic%20fantasy%20navigator%20theme%2C%20deep%20blue%20and%20warm%20gold%20contrast%2C%20painterly%20digital%20art%2C%20collection%20book%20cover%2C%20mystical%20mood%2C%20high%20detail&width=800&height=1000&seq=nami-c-02&orientation=portrait",
    count: 58,
    desc: "夏橘的幻想连载系列,以星图为引、以罗盘为伴的宏大冒险。",
  },
  {
    id: 3,
    name: "《风与海浪》",
    cover: "https://readdy.ai/api/search-image?query=anime%20collection%20cover%20of%20a%20young%20woman%20with%20orange%20hair%20on%20a%20ship%20prow%20with%20windswept%20hair%20facing%20massive%20rolling%20waves%20and%20white%20foam%2C%20dynamic%20ocean%20power%20mood%2C%20warm%20and%20teal%20color%20grading%2C%20painterly%20digital%20art%2C%20collection%20book%20cover%2C%20epic%20composition%2C%20high%20detail&width=800&height=1000&seq=nami-c-03&orientation=portrait",
    count: 36,
    desc: "罗盘先生以厚涂技法描绘的海之力量,每幅都是可作壁纸的横幅大片。",
  },
  {
    id: 4,
    name: "《青涩的橘子》",
    cover: "https://readdy.ai/api/search-image?query=anime%20collection%20cover%20of%20a%20shy%20young%20woman%20with%20orange%20hair%20holding%20a%20green%20tangerine%20blushing%20softly%2C%20pastel%20watercolor%20style%2C%20delicate%20youthful%20romance%20mood%2C%20soft%20spring%20light%2C%20light%20cream%20background%2C%20collection%20book%20cover%2C%20tender%20gentle%20palette%2C%20high%20detail&width=800&height=1000&seq=nami-c-04&orientation=portrait",
    count: 29,
    desc: "阿汐细腻水彩之作,青涩与温柔交织的成长物语,充满少年感。",
  },
];

export const artists: Artist[] = [
  {
    id: 1,
    name: "枫间晓",
    alias: "@FengjianXiao",
    style: "柔和光影",
    works: 128,
    fans: 8600,
    avatar: "https://readdy.ai/api/search-image?query=soft%20anime%20style%20avatar%20portrait%20of%20a%20gentle%20artist%20with%20warm%20smile%20and%20brown%20hair%2C%20painterly%20rendering%2C%20warm%20golden%20backdrop%2C%20cozy%20creative%20vibe%2C%20square%20avatar%20illustration%2C%20high%20quality%20digital%20art&width=600&height=600&seq=nami-a-01&orientation=squarish",
    intro: "擅长用温暖的午后光线描绘日常瞬间,画面干净治愈,极受欢迎。",
  },
  {
    id: 2,
    name: "夏橘",
    alias: "@XiaJu_Art",
    style: "清新幻想",
    works: 96,
    fans: 5300,
    avatar: "https://readdy.ai/api/search-image?query=soft%20anime%20style%20avatar%20portrait%20of%20a%20young%20artist%20with%20short%20orange%20hair%20and%20bright%20eyes%2C%20clean%20painterly%20rendering%2C%20light%20cream%20backdrop%2C%20fresh%20creative%20vibe%2C%20square%20avatar%20illustration%2C%20high%20quality&width=600&height=600&seq=nami-a-02&orientation=squarish",
    intro: "热衷星图与幻想题材,色彩明快,叙事感强,是连载系列人气画师。",
  },
  {
    id: 3,
    name: "罗盘先生",
    alias: "@MrCompass",
    style: "高质感厚涂",
    works: 74,
    fans: 12100,
    avatar: "https://readdy.ai/api/search-image?query=soft%20anime%20style%20avatar%20portrait%20of%20a%20calm%20male%20artist%20with%20dark%20hair%20and%20a%20thoughtful%20expression%2C%20textured%20painterly%20rendering%2C%20deep%20warm%20brown%20backdrop%2C%20serious%20creative%20vibe%2C%20square%20avatar%20illustration%2C%20high%20quality&width=600&height=600&seq=nami-a-03&orientation=squarish",
    intro: "以厚重笔触与电影级光影见长,其海景横幅作品长期霸占下载榜。",
  },
  {
    id: 4,
    name: "阿汐",
    alias: "@AXi_Water",
    style: "细腻水彩",
    works: 63,
    fans: 4200,
    avatar: "https://readdy.ai/api/search-image?query=soft%20anime%20style%20avatar%20portrait%20of%20a%20gentle%20female%20artist%20with%20long%20black%20hair%20and%20a%20quiet%20smile%2C%20delicate%20watercolor%20rendering%2C%20soft%20pink%20and%20cream%20backdrop%2C%20tender%20creative%20vibe%2C%20square%20avatar%20illustration%2C%20high%20quality&width=600&height=600&seq=nami-a-04&orientation=squarish",
    intro: "用水彩晕染出青涩与温柔,笔下的成长物语细腻动人,极具少年感。",
  },
];

export const faqItems: FaqItem[] = [
  {
    q: "这些娜美同人图片可以直接保存使用吗?",
    a: "站内的同人插画与壁纸仅供个人收藏与欣赏使用。如需用于商业用途、转载或二次创作,请务必提前联系对应画师获取授权,尊重每一位创作者的心血。",
  },
  {
    q: "网站多久更新一次新作品?",
    a: "我们会在每周定期整理并上新,涵盖新晋画师投稿与经典精选。关注页脚处的订阅,即可第一时间收到更新通知。",
  },
  {
    q: "如何投稿或推荐自己喜欢的画师作品?",
    a: "你可以通过页面底部的联系表单提交作品链接与画师信息,我们审核后会尽快联系画师确认收录意向,并标注完整来源。",
  },
  {
    q: "高清壁纸会提供多个分辨率吗?",
    a: "目前我们为每张壁纸提供适合手机与桌面两个主要分辨率的版本,部分横幅作品还会附带平板比例,方便你按设备下载。",
  },
  {
    q: "画集系列可以打包下载吗?",
    a: "为保护画师权益,画集暂不提供一键打包。你可以逐幅收藏,或进入画师主页了解其官方画集购买渠道。",
  },
];